import { Component, OnInit, OnDestroy } from '@angular/core';
import { TenantSwitchService, AvailableTenantDto } from '../../../services/tenant-switch.service';
import { ToastService } from '../../../services/toast-service';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-tenant-selector',
  templateUrl: './tenant-selector.component.html',
  styleUrls: ['./tenant-selector.component.scss']
})
export class TenantSelectorComponent implements OnInit, OnDestroy {
  availableTenants: AvailableTenantDto[] = [];
  currentTenant: AvailableTenantDto | null = null;
  switching = false;
  dropdownOpen = false;
  private destroy$ = new Subject<void>();

  constructor(
    private tenantService: TenantSwitchService,
    private toastService: ToastService,
    private translate: TranslateService
  ) {}

  ngOnInit(): void {
    // Subscribe to tenant changes
    this.tenantService.availableTenants$
      .pipe(takeUntil(this.destroy$))
      .subscribe(tenants => {
        this.availableTenants = tenants;
      });

    this.tenantService.currentTenant$
      .pipe(takeUntil(this.destroy$))
      .subscribe(tenant => {
        this.currentTenant = tenant;
      });

    // Initial load
    this.loadTenants();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  loadTenants(): void {
    this.tenantService.loadAvailableTenants().subscribe({
      error: (error) => {
        console.error('Failed to load tenants:', error);
        // Silent fail - user may not have multi-tenant access
      }
    });
  }

  switchTenant(tenant: AvailableTenantDto): void {
    if (tenant.isCurrent || this.switching) {
      return;
    }

    this.switching = true;
    this.dropdownOpen = false;

    this.tenantService.switchTenant(tenant.domainName).subscribe({
      next: (response) => {
        window.location.href = response.redirectUrl;
      },
      error: (error) => {
        console.error('Failed to switch tenant:', error);
        this.toastService.show({
          type: 'error',
          data: [this.translate.instant('TenantSwitch.SwitchFailed')]
        });
        this.switching = false;
      }
    });
  }

  toggleDropdown(): void {
    this.dropdownOpen = !this.dropdownOpen;
  }

  hasMultipleTenants(): boolean {
    return this.availableTenants.length > 1;
  }

  closeDropdown(): void {
    this.dropdownOpen = false;
  }
}
